module.exports = __webpack_public_path__ + "static/media/DES19.e6c458fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/home/breakfast/images/DES19.jpg
// module id = 638
// module chunks = 0